// Locales rendered right-to-left (DESIGN.md: layouts mirror for these).
export const RTL_LOCALES = ["ar", "he", "fa", "ur"];

export function useIsRtl() {
  const { locale } = useI18n();
  return computed(() => RTL_LOCALES.includes(locale.value));
}
